module.exports = __webpack_public_path__ + "media/images/emblems/Riehen-coat_of_arms-2a462352ede157028e60d2b31565e40d.svg";